import fetch from '@/utils/fetch'
import constants from '@/utils/constants'

// 获取七牛token
export function getQiNiuToken() {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organize/oss/token',
    method: 'post'
  })
}

// 改变语言
export function turnLang() {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/user/changeLanguage',
    method: 'post'
  })
}

// 获取地区
export function getAreaData(code: any) {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organize/areaData',
    method: 'post',
    data: {
      code: code || ''
    }
  })
}

/**
 * 校区列表
 */
export const campusList = (params:any) => {
  return fetch({
    url: constants.API_MODULE_PATH.HEALTH + '/organize/manager/campus/list',
    method: 'post',
    data: {
      ...params
    }
  })
}

/**
 * 集成平台token
 */
export const fitToken = (params:any) => {
  return fetch({
    url: '/api-evaluation/common/fit/token',
    method: 'post',
    data: {
      ...params
    }
  })
}

/**
 * 集成平台token
 */
export const childToken = (params:any) => {
  return fetch({
    url: '/api-exercise/common/child/token',
    method: 'post',
    data: {
      ...params
    }
  })
}
